function App() {
  return (
    <div className="main">
    <div className="main__audio">
      <h3>This blog post has been recorded to be audio accessible to the visually impaired.</h3>
      <audio controls src="./media/todays-entry-doors-final.mp3" type="audio/mp3"></audio>
    </div>
      <img className="main__img-1" src="./img/a-welcoming-orange-county-door.png" alt="A Welcoming Orange County Door" description="A Beautiful Front Door With A Welcome Sign" />
      <h1 className="mb-sm">
        This Is How To Keep Your New
        <br />
        Orange County Front Entry Door Looking Brand New
      </h1>
      <h2 className="main__subheading">
        Even Though The Best-In-Class Fiberglass Material Practically Maintains Itself!
      </h2>
      <h2 className="mb-sm">Why Does Such A Strong Material Need To Be Maintained, Anyway?</h2>
      <p className="mb-md">
        Luckily for you, fiberglass doesn’t need much maintenance. Unlike wood
        or steel doors, fiberglass doors don't warp or dent. Does that mean
        fiberglass front entry doors appear cheap or fake, and especially in
        Orange County? Not at all! Quite the opposite, in fact. <br/><br/>Fiberglass doors
        are breathtakingly attractive <strong>and astoningishly durable</strong>. It’s the best
        of both worlds. Fiberglass doors can emulate the most ornate of wooden
        doors while simultaneously being a tougher material. Even in the rare
        event of damage to your fiberglass door, if it was originally installed
        by Today’s Entry Doors, there is <a href="https://todaysentrydoors.com/why-us/lifetime-warranty/">a lifetime warranty</a>.<br/><br/> What’s more,
        Today’s Entry Doors also offers a <strong>2-year labor guarantee warranty</strong>. So…
        with all of that said, why would you even need to maintain your front
        entry door in the first place if our fiberglass doors are that good? <br/><br/>
        Well, there are still some <strong>simple</strong> things you can do as the proud owner
        of the best new front door on the block to make sure your fiberglass
        door is looking top-notch. Here, we list three key things to do that
        could save you a lot of troubleshooting in the future.
      </p>

      <h2 className="mb-md" >
        3 Simple Tips And Tricks To Maintaining A Flawless Front Entry Door
      </h2>

      <img className="main__img-2" src="./img/orange-county-resident-cleaning-front-door.png" alt="Orange County Resident Cleaning Front Door" description="A Good Homeowner Maintaining Front Entry Door" />

      <h3>1. Check For A Tight Seal To Prevent Unnoticed Air From Escaping</h3>
      <p className="mb-md">
        As Orange County residents know all too well, the summer heat can be
        punishing. For this reason alone, we don’t want any of your hard-earned
        money going to waste because of an air leak.<br/><br/> While our doors are made
        with the best insulating material from one of our most trusted
        manufacturers (<a href="https://todaysentrydoors.com/explore-doors/by-brand/therma-tru/">Therma-Tru</a>), we do recommend giving your weather strips a
        quick once-over every now and again.<br/><br/> Despite our <a href="https://todaysentrydoors.com/why-us/proven-process/">highly-professional
        installation process</a>, life happens. With people (and pets) coming and
        going, big objects being lifted in and out, and kids barreling through,
        damage can happen to your seals. For this, we recommend the following
        simple process performed once a month to ensure the tightest seal
        possible on your fiberglass front entry door:<br/><br/> Run your hand along the
        length of each weather strip, checking for damage. The weather strip
        should never be clustered, or overlapping in any corner of the front
        entry door.<br/><br/> Next, close the door and run your hand along the gaps in the
        door on either side, bottom, and top. Do you feel any air coming
        through? If so, reinspect your weather strip to make sure it is
        positioned correctly, and if needed, replace your weather strip on any
        damaged side(s).
      </p>
      <h3>2. Check The Door Sweep For Air Leaking And Obstruction</h3>
      <p className="mb-md">
        While it may not be initially obvious, the door sweep is also an
        integral part of keeping your front entry door completely sealed. Make
        sure, as with the weather strips, that <strong>no air is escaping</strong>. Also ensure
        that the sweep is not hindering the natural movement of the door when
        opening and closing it. <br/><br/>The sweep should never create too much dragging.
        If so, it could get damaged, in which case you may want to consider
        replacing the door sweep.
      </p>
      <h3>3. Wash Dust And Debris From Your Front Entry Door’s Surface</h3>
      <p className="mb-md">
        There are two low-to-no cost methods you can use to ensure your
        fiberglass front entry door is looking brand new. <br/><br/>The first method
        involves mixing one cup of white vinegar mixed with one gallon of water.
        From there, use a gentle lint-free cloth or sponge to gently wipe away
        the debris and dirt. With another lint-free, clean and dry towel, wipe
        away the excess moisture.<br/><br/> The second method to cleaning your new
        fiberglass front entry door requires another easy and cheap technique.
        Simply mix two tablespoons of dish soap, two cups of warm water, and a
        dash of baking soda in a spray bottle and apply generously to your door.<br/><br/>
        From there, wipe with a clean, dry, lint-free towel.<br/><br/> For more stubborn
        dirt and grime, we recommend using a <strong>soft bristle brush</strong>. Just be mindful
        with this method, ensuring that the bristles are not too hard or harsh.
      </p>

      
      <h2 className="mb-sm">
        The Top Thing We Do Not Recommend To Maintain Your New Front Entry Door
      </h2>

      <img className="main__img-2" src="./img/orange-county-contractor-sanding-door.png" alt="Orange County Resident Cleaning Front Door" description="A Good Homeowner Maintaining Front Entry Door" />
      <p className="mb-md">
        We know, this was an article about tips and tricks of things <strong>to</strong> do in
        order to maintain your lovely fiberglass front entry door. But we also
        want to take this opportunity to talk about one thing we recommend you <strong>not to do regarding your front entry door</strong>
        .<br/><br/> The hard truth, and
        especially in Orange County, is that the sun is punishing on all
        surfaces – especially on front entry doors. Unless there is a
        substantial amount of shade being generated over your door at all hours
        of the day, fading is bound to happen in time.<br/><br/> It’s hard to say when
        your front door will begin to show fading as it depends on color and
        exposure to the sun. But it will inevitably happen, no matter how
        professional the installation and robust the material.<br/><br/> When this does
        happen, you may be tempted to take matters into your own hands. However,
        we <a href="https://todaysentrydoors.com/blog/can-you-repaint-or-restain-fiberglass-entry-doors/">highly recommend getting a professional to do it for you</a>. Unless you
        know exactly what is involved in sanding, resurfacing, reapplying
        protectant, and repainting please <a href="https://todaysentrydoors.com/">leave it to the professionals</a>.<br/><br/> One
        thing that heavily plays a role in fading is the quality of your front
        door. Plain and simple. Was it installed by another Orange County front
        entry door contractor who has lower standards than Today’s Entry Doors?<br/><br/>
        If so, it is likely to fade faster as we use only the crème de la crème
        of materials:<br/><br/>
        <ul>
          <li><a href="https://todaysentrydoors.com/explore-doors/by-brand/therma-tru/">Therma-Tru</a> </li>
          <li><a href="https://todaysentrydoors.com/explore-doors/by-brand/jeld-wen/">Jeld-Wen</a><a href="https://www.jeld-wen.com/en-us/2022/0627/jeld-wen-one-of-americas-most-trustworthy-companies"> (recently named one of America’s most trusted companies)</a>   </li>
          <li><a href="https://todaysentrydoors.com/explore-doors/by-brand/masonite/">Masonite</a></li>

        </ul><br/>
        We don’t mean to
        brag, but we take pride in our manufacturing choice. Anything less will
        show.
      </p>

      <h2 className="mb-md">Has Your Fiberglass Front Entry Door Started To Fade?</h2>
      <p>
        If your front entry door has started to fade, don’t hesitate to reach
        out to Today’s Entry Doors for a <a href="https://todaysentrydoors.com/contact-us/">free, no-hassle, and no-pressure
        consultation</a>. <br/><br/>Many companies out there talk the talk but never walk the
        walk. We don’t just hound you for a sale and then forget about you when
        the job is done. We’re with you every step of the way, through and
        through.<br/><br/> If you’re ready to get started immediately and get the ball
        rolling faster than a consultation, <strong>call us now at (714)974-5728 today</strong>!
      </p>
    </div>
  );
}

export default App;
